import { LimitationType } from '../api-client';

export const limitationTypeTag = (t?: LimitationType) => {
	if (!t) return { typeString: '-', color: 'grey' };
	let typeString = 'Customer';
	let color = 'gold';
	if (t === LimitationType.Cluster) {
		typeString = 'Cluster';
		color = 'blue';
	} else if (t === LimitationType.OperatingCountry) {
		typeString = 'Operating Country';
		color = 'green';
	} else if (t === LimitationType.ResponsabilityArea) {
		typeString = 'Responsability Area';
		color = 'purple';
	} else if (t === LimitationType.SalesChannel) {
		typeString = 'Sales Channel';
		color = 'magenta';
	}
	return { typeString, color };
};
